import vars from '../helpers';

let $storiesButton = $('.stories__slide');
let $discoveriesButton = $('.discoveries__content');
let $achievementsButton = $('.achievements__event');
let $popupClose = $('.popup__close, .popup__overlay');
let popupActive = false;

let popupChange = (target) => {
	let $popupActive = $('.popup.is-active');
	let $overlayActive = $popupActive.find('.popup__overlay');
	let $bodyActive = $popupActive.find('.popup__body');
	let $mouseActive = $popupActive.find('.popup__mouse');
	let $sectionActive = $(`.${$popupActive.closest('.home__section').data('section')}`);

	if (popupActive) {
		gsap
			.timeline()
			.to($overlayActive, {
				onStart() {
					$popupActive.addClass('is-close');
				},
				onComplete() {
					$popupActive.removeClass('is-close').removeClass('is-active');
					$mouseActive.addClass('is-hidden');
				},
				duration: 0.5,
				opacity: 0,
				clearProps: true,
			})
			.to($bodyActive, {
				duration: 0.5,
				x: '100%',
				opacity: 0,
				clearProps: true,
			}, '<');
	}

	if (target === 'close') {
		popupActive = false;
		$sectionActive.removeAttr('data-popup');
		vars.$document.trigger('scroll-animate-true');

		return;
	}

	let section = target.closest('.home__section').data('section');
	let slide = target.closest('.swiper-slide').data('slide');
	let $popup = $(`.popup[data-section="${section}"][data-color="${slide}"]`);
	let $overlay = $popup.find('.popup__overlay');
	let $body = $popup.find('.popup__body');
	let $scroll = $popup.find('.popup__scroll');
	let $content = $popup.find('.popup__content');
	let $mouse = $popup.find('.popup__mouse');
	let $section = $(`.${section}`);

	gsap
		.timeline()
		.from($overlay, {
			onStart() {
				$popup.addClass('is-active');
				$scroll.scrollTop(0, 0)

				if (!vars.isMobile() && $content.innerHeight() > $popup.innerHeight()) {
					$mouse.removeClass('is-hidden');
				}
			},
			duration: 0.5,
			opacity: 0,
			clearProps: true,
		})
		.from($body, {
			duration: 0.5,
			x: '100%',
			clearProps: true,
		}, '<');

	popupActive = true;
	$section.attr('data-popup', true);
	vars.$document.trigger('scroll-animate-false');
}

$storiesButton.on('click', (e) => {
	let $target = $(e.currentTarget);

	popupChange($target);
});

$discoveriesButton.on('click', (e) => {
	let $target = $(e.currentTarget);

	$('.discoveries__navigation--popup').fadeIn(300);
	vars.$document.trigger('discoveries-slider-stop');

	popupChange($target);
});

$achievementsButton.on('click', (e) => {
	let $target = $(e.currentTarget);

	popupChange($target);
});

$popupClose.on('click', (e) => {
	let $target = $(e.currentTarget);
	let section = $target.closest('.home__section').data('section');

	if (section === 'discoveries') {
		$('.discoveries__navigation--popup').fadeOut(300);
		vars.$document.trigger('discoveries-slider-start');
	}

	popupChange('close');
});

vars.$document
	.on('click', '.js-popup-open', (e) => {
		$(`.popup[data-name="${e.currentTarget.dataset.popup}"]`)
			.addClass('is-active')
			.fadeIn(300);

		vars.$document.trigger('scroll-animate-false');
	})
	.on('click', '.js-popup-close', (e) => {
		$(`.popup[data-name="${e.currentTarget.dataset.popup}"]`)
			.removeClass('is-active')
			.fadeOut(300);

		vars.$document.trigger('scroll-animate-true');
	})
	.on('click', '.popup[data-name="team"] .popup__close, .popup[data-name="team"] .popup__overlay', (e) => {
		$(e.currentTarget)
			.closest('.popup')
			.removeClass('is-active')
			.fadeOut(300);

		vars.$document.trigger('scroll-animate-true');
	})
	.on('stories-slide-change', () => {
		let $slideActive = $('.stories').find('.stories__slide.swiper-slide-active');

		if (popupActive) {
			popupChange($slideActive)
		}
	})
	.on('discoveries-slide-change', () => {
		let $slideActive = $('.discoveries').find('.discoveries__slide.swiper-slide-active');

		if (popupActive) {
			popupChange($slideActive)
		}
	})
	.on('achievements-slide-change', () => {
		let $slideActive = $('.achievements').find('.achievements__slide.swiper-slide-active');

		if (popupActive) {
			popupChange($slideActive)
		}
	});
